import { EMPTY_ARRAY, EMPTY_MAP, EMPTY_OBJECT, type ICounterparty } from '@talos/kyoko';
import { useGetCounterpartiesQuery } from 'ava/src/providers/AppStateProvider/streamingDataSlice';
import { useMemo } from 'react';

/**
 * (RTK Sourced) Result from the useGetCounterpartiesQuery hook
 */
export function useCounterpartiesQueryData(): {
  /** All counterparties from the query */
  counterparties: ICounterparty[];
  /** All counterparties from the query by name */
  counterpartiesByName: Map<string, ICounterparty>;
} {
  const { data: counterpartiesByName } = useGetCounterpartiesQuery(EMPTY_OBJECT);

  return useMemo(() => {
    if (!counterpartiesByName) {
      return {
        counterparties: EMPTY_ARRAY,
        counterpartiesByName: EMPTY_MAP,
      };
    }

    return {
      counterparties: Array.from(counterpartiesByName.values()),
      counterpartiesByName,
    };
  }, [counterpartiesByName]);
}
